import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "@songtradr-one/components-frontend";
import { AppId } from "@songtradr-one/shared-common";
import { App } from "./app/App";
import { config } from "./app/config/config";
import { env } from "./app/env/env";

Sentry.init({
  dsn: config.sentryDsn,
  environment: BUILD_CONFIGURATION,
  initialScope: {
    tags: { node_env: env.NODE_ENV, app_id: AppId.SongtradrStudio },
  },
  enabled: !["development", "test"].includes(env.NODE_ENV),
  sendDefaultPii: false,
});

const root = createRoot(document.getElementById("root") as HTMLElement, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <ThemeProvider mode="dark">
      <App />
    </ThemeProvider>
  </StrictMode>,
);
